import { Flex } from 'shared/ui'

export default Flex
